export default __webpack_public_path__ + "static/asiaberlin-741015d893fe2641e7d6d4ce2ae5bd0c.png";